module.exports = __webpack_public_path__ + "img/home-bg4-1.3a3015c6.png";